import React, { FC } from 'react';

interface SVGTwitterIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const SVGTwitterIcon: FC<SVGTwitterIconProps> = ({
  width = '32',
  height = '32',
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.3677 11.7792C26.6697 18.6023 21.5522 26.2023 12.4787 26.2023C9.82712 26.2054 7.23073 25.4496 5 24.0254C7.58035 24.3333 10.1782 23.6112 12.2232 22.0177C10.1345 21.9789 8.30183 20.6247 7.66323 18.6484C8.39553 18.7885 9.15042 18.7595 9.86968 18.5638C7.57251 18.0951 5.93467 16.0706 5.96774 13.7407C6.64636 14.1161 7.40561 14.3245 8.18194 14.3484C6.02676 12.9371 5.34853 10.1034 6.63355 7.8792C9.11216 10.9117 12.7711 12.7547 16.6981 12.9484C16.2005 10.8122 17.2061 8.60979 19.1517 7.57485C21.0972 6.53991 23.4995 6.92949 25.0129 8.52535C26.105 8.31077 27.1523 7.91276 28.1097 7.34843C27.7459 8.47196 26.9839 9.42598 25.9652 10.0331C26.9328 9.9173 27.8775 9.65801 28.7677 9.26382C28.1243 10.2371 27.3116 11.0888 26.3677 11.7792Z"
      fill={color}
    />
  </svg>
);

export default SVGTwitterIcon;
